export const GetTidbitsByIDActionTypes = {
  GET_TIDBITS_BY_ID_LOADING: "GET_TIDBITS_BY_ID_LOADING",
  GET_TIDBITS_BY_ID_ERROR: "GET_TIDBITS_BY_ID_ERROR",
  GET_TIDBITS_BY_ID_SUCCESS: "GET_TIDBITS_BY_ID_SUCCESS",
};
